// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"64910560","81":"ad703ef4","129":"6d50b2da","304":"fb171230","894":"c14cedaa"}[chunkId] + ".chunk.js";
};